export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"}],"link":[{"rel":"preconnect","href":"https://s3.amazonaws.com/"},{"rel":"dns-prefetch","href":"https://s3.amazonaws.com"},{"rel":"preconnect","href":"https://cdnjs.cloudflare.com/"},{"rel":"dns-prefetch","href":"https://cdnjs.cloudflare.com/"},{"rel":"preconnect","href":"https://old.customusb.com"},{"rel":"dns-prefetch","href":"https://old.customusb.com"},{"rel":"preconnect","href":"https://www.customusb.com"},{"rel":"dns-prefetch","href":"https://www.customusb.com"},{"rel":"preconnect","href":"https://cdn.customusb.com"},{"rel":"dns-prefetch","href":"https://cdn.customusb.com"},{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com"},{"rel":"preload","as":"style","onload":"this.onload=null;this.rel='stylesheet'","href":"https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap"}],"style":[{"children":"\n                html, body {\n                  font-family: 'Inter', sans-serif;\n                }\n              ","type":"text/css"}],"script":[],"noscript":[],"titleTemplate":"%s CustomUSB"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = true

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = true

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true